module.exports = __webpack_public_path__ + "img/9.044f3a56.jpg";